import React, {FC, useEffect, useRef, useState} from "react";
import {ExternalChatOrganization} from "domain-entities";
import {Avatar, makeStyles} from "@material-ui/core";
import {useGetOrganizationAvatarUrl} from "./OrganizationHelper";
import {Skeleton} from "@material-ui/lab";
import FadeInBox from "Components/Layout/FadeInBox";

interface Props {
  organization: ExternalChatOrganization;
  isCirlce?: boolean;
}

const OrganizationAvatar: FC<Props> = (props) => {
  const classes = useStyles();
  const [src, setSrc] = useState<string>();
  const [isLoading, setIsLoading] = useState(true);
  const getOrganizationAvatarUrl = useGetOrganizationAvatarUrl();
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    async function startEffect() {
      try {
        const organizationAvatarUrl = await getOrganizationAvatarUrl(
          props.organization
        );

        if (isMountedRef.current) {
          setSrc(organizationAvatarUrl);
        }
      } finally {
        if (isMountedRef.current) {
          setIsLoading(false);
        }
      }
    }

    startEffect();

    return () => {
      isMountedRef.current = false;
    };
  }, [props.organization, getOrganizationAvatarUrl]);

  if (isLoading) {
    return (
      <FadeInBox delayIndex={1}>
        <Skeleton
          className={props.isCirlce ? undefined : classes.skeleton}
          variant={props.isCirlce ? "circle" : "rect"}
          width={AVATAR_SIZE}
          height={AVATAR_SIZE}
        />
      </FadeInBox>
    );
  } else {
    return (
      <FadeInBox>
        <Avatar
          className={classes.avatar}
          variant={props.isCirlce ? "circle" : "rounded"}
          src={src}
        />
      </FadeInBox>
    );
  }
};

export default OrganizationAvatar;

const AVATAR_SIZE = 48;

const useStyles = makeStyles({
  avatar: {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
  },
  skeleton: {
    borderRadius: 4,
  },
});
